var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-select',{staticStyle:{"width":"100%"},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},_vm._l((_vm.option),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }